import React, { useState, useEffect } from "react";

import './styles.css';

import collaboratorServices from "../../../../../services/admFin/collaboratorServices";
import estados_e_cidades from "../../../../../services/estadosECidades";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import Notice from "../../../../../components/Notice";
import SelectCompaniesPopUp from "./SelectCompaniesPopUp";
import { FaBuilding, FaPersonBooth, FaRegFolder } from "react-icons/fa";


export default function CollaboratorPopUp(props) {
    const [nome, setNome] = useState("");
    const [documento, setDocumento] = useState("");
    const [logradouro, setLogradouro] = useState("");
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");
    const [bairro, setBairro] = useState("");
    const [cep, setCep] = useState("");
    const [ddi, setDdi] = useState("");
    const [iso2, setIso2] = useState("");
    const [telefone, setTelefone] = useState("");
    const [isValidNumber, setIsValidNumber] = useState('');
    const [foto, setFoto] = useState("");
    const [data_admissao, setData_admissao] = useState("");
    const [data_demissao, setData_demissao] = useState("");
    const [inativo, setInativo] = useState(false);
    const [observacao, setObservacao] = useState("");
    const [salario, setSalario] = useState("");
    const [cargo, setCargo] = useState("");
    const [ferias, setFerias] = useState("");

    const [empresas, setEmpresas] = useState([]);
    const [listaCidades, setListaCidades] = useState([]);
    const [visibility, setVisibility] = useState(false);

    useEffect(() => {
        if (props.collaborator && props.companies && props.companies.length > 0 )
            setCompaniesIndexes(props.collaborator, props.companies);
        else
            setEmpresas([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.collaborator]);

    useEffect(() => {
        if (props.collaborator && Object.keys(props.collaborator).length > 0) {
            setNome(props.collaborator.nome);
            setDocumento(props.collaborator.documento);
            setLogradouro(props.collaborator.logradouro);
            setCidade(props.collaborator.cidade);
            setEstado(props.collaborator.estado);
            setBairro(props.collaborator.bairro);
            setCep(props.collaborator.cep);
            setDdi(props.collaborator.ddi ? props.collaborator.ddi : "+55");
            setIso2(props.collaborator.iso2_ddi ? props.collaborator.iso2_ddi : "br");
            setTelefone(props.collaborator.telefone);
            setIsValidNumber(true);
            setFoto(props.collaborator.foto);
            setData_admissao(props.collaborator.data_admissao);
            setData_demissao(props.collaborator.data_demissao);
            setInativo(props.collaborator.inativo);
            setObservacao(props.collaborator.observacao);
            setSalario(props.collaborator.salario);
            setCargo(props.collaborator.cargo);
            setFerias(props.collaborator.ferias);
        }
        if (props.collaborator && props.companies && props.companies.length > 0)
            setCompaniesIndexes(props.collaborator, props.companies);
    }, [props.collaborator, props.companies]);


    useEffect(() => {
        if (estado) {
            const index = estados_e_cidades.estados.findIndex(estadoAux => estado.split(' - ')[0] === estadoAux.sigla)
            if (index !== -1)
                setListaCidades(estados_e_cidades.estados[index].cidades.slice());
            else
                setListaCidades([]);
        }
    }, [estado]);

    function setCompaniesIndexes(collaborator, companies = []) {
        if (!collaborator || !collaborator.empresas) return;

        const indexes = [];
        companies.forEach((obj, index) => {
            collaborator.empresas.forEach(objAccount => {
                if (objAccount.id === obj.id) {
                    indexes.push(index);
                    return;
                }
            })
        });
        setEmpresas(indexes);
    }

    return (
        <Popup
            icon={<FaPersonBooth />}
            tittle={props.tittle}
            visibility={props.visibility}
            setVisibility={props.setVisibility}
        >
            <Input
                label="Nome*"
                placeholder="Digite o nome do colaborador"
                id="new-collaborator-popup-nome"
                onChange={(e) => setNome(e.target.value)}
                value={nome}
            />

            <Input
                label="CPF*"
                placeholder="Digite o CPF do colaborador"
                id="new-collaborator-popup-cpf"
                onChange={(e) => setDocumento(String(e.target.value).replace(/\D/g, ''))}
                value={documento}
            />
            <Input
                label="Data de Admissão*"
                type="date"
                placeholder="Digite a data de admissão do colaborador"
                id="new-collaborator-popup-admission-date"
                onChange={(e) => setData_admissao(e.target.value)}
                value={data_admissao}
            />
            <Input
                label="Colaborador Inativo?"
                type="checkbox"
                placeholder="Sim"
                id='popup-new-bill-paid'
                onChange={(event) => {
                    setInativo(!inativo)
                }}
                value={inativo}
                checked={inativo}
            />
            {
                inativo ?
                <Input
                    label="Data de Demissão*"
                    type="date"
                    placeholder="Digite a data de demissão do colaborador"
                    id="new-collaborator-popup-demission-date"
                    onChange={(e) => setData_demissao(e.target.value)}
                    value={data_demissao}
                />
                :
                null
            }
            <Input
                label="Salário*"
                type="currency"
                placeholder="Salário do colaborador"
                id="new-collaborator-popup-salary"
                onChange={(e) => setSalario(e.target.value)}
                value={salario}
            />
            <Input
                label="Cargo*"
                placeholder="Cargo do colaborador"
                id="new-collaborator-popup-job"
                onChange={(e) => setCargo(e.target.value)}
                value={cargo}
            />
            <Input
                label="Dias de férias*"
                type="number"
                min="1"
                max="30"
                placeholder="Número de dias de férias do colaborador"
                id="new-collaborator-popup-job"
                onChange={(e) => setFerias(e.target.value)}
                value={ferias}
            />
            <Input
                label='Foto'
                type='photo'
                accept="image/*"
                placeholder="Selecione uma foto"
                showFileLabel
                filePreview
                className='new-collaborator-form-file-input'
                id='new-collaborator-form-photo'
                onChange={setFoto}
                value={foto ? (typeof foto === "string" ? foto : URL.createObjectURL(foto)) : ''}
            />


            <div className="line">
                <Input
                    label="CEP"
                    placeholder="Digite o CEP"
                    id="new-collaborator-popup-cep"
                    onChange={(e) => setCep(String(e.target.value).replace(/\D/g, ''))}
                    value={cep}
                />

                <Input
                    label="Estado"
                    type="select"
                    options={estados_e_cidades.estados.map((estado) => estado.sigla)}
                    placeholder="Selecione o estado do colaborador"
                    id="new-collaborator-popup-estado"
                    onChange={(e) => setEstado(e.target.value)}
                    value={estado}
                />
            </div>

            <Input
                label="Cidade"
                type="select"
                // options={estado ? (aux = estados_e_cidades.estados.find(estadoAux => estado.split(' - ')[0] == estadoAux.sigla)) => aux ? aux.cidades : null : null}
                options={listaCidades}
                placeholder={listaCidades.length ? "Selecione a cidade do colaborador" : "Selecione o estado do colaborador primeiro"}
                id="new-collaborator-popup-cidade"
                onChange={(e) => setCidade(e.target.value)}
                value={cidade}
            />

            <Input
                label="Bairro"
                placeholder="Digite o bairro do colaborador"
                id="new-collaborator-popup-bairro"
                onChange={(e) => setBairro(e.target.value)}
                value={bairro}
            />

            <Input
                label="Logradouro"
                placeholder="Digite o logradouro do colaborador"
                id="new-collaborator-popup-logradouro"
                onChange={(e) => setLogradouro(e.target.value)}
                value={logradouro}
            />

            <div className="line">

                <Input
                    label='Telefone'
                    type='tel'
                    placeholder="Telefone"
                    id='new-collaborator-popup-telefone'
                    onChange={(event) => setTelefone(event.target.value)}
                    iso2={iso2}
                    setIso2={setIso2}
                    setDialCode={setDdi}
                    setIsValidNumber={setIsValidNumber}
                    value={telefone}
                />
            </div>

            <Input
                label="Observação"
                type="textarea"
                placeholder="Digite observações sobre o colaborador"
                id="new-collaborator-popup-observations"
                onChange={(e) => setObservacao(e.target.value)}
                value={observacao}
            />

            
            {
                !props.companies || props.companies.length === 0 ?
                    <Notice>Nenhuma Empresa para selecionar</Notice>
                    :
                    <div className="new-collaborator-popup-button-container">
                        <label className=" input-label new-collaborator-popup-label-companies">Empresas</label>
                        <button className="light-blue" onClick={() => setVisibility(true)}>{empresas.length ? `${empresas.length} empresas selecionadas` : "Selecione empresas para ligar ao colaborador"}</button>
                        <SelectCompaniesPopUp
                            visibility={visibility}
                            setVisibility={setVisibility}
                            companies={props.companies}
                            markedCompanies={empresas}
                            setCompanies={setEmpresas}
                        />
                    </div>
                
            }

            <button
                onClick={() => {
                    const ids = empresas.map(idx => props.companies[idx].id);
                    props.onClick({
                        nome,
                        documento,
                        data_admissao,
                        data_demissao,
                        inativo,
                        logradouro,
                        cidade,
                        estado: estado ? estado : null,
                        bairro,
                        cep,
                        ddi,
                        iso2,
                        telefone,
                        isValidNumber,
                        foto,
                        observacao,
                        salario,
                        cargo,
                        ferias,
                        empresas: ids
                    });
                }}
            >{props.buttonTittle}</button>

        </Popup>
    )
}